<template>
  <v-container fluid>
    <v-dialog v-model="this.$store.getters['Auth/is_avis_open']" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <h4 class="headline">{{ formTitle }}</h4>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="colll" cols="12" sm="12" md="12">
                <v-select :items="filteredAvis" v-model="notice.id" label="Sélectionner l’avis concerné"
                  :item-text="item => `${item.noticeType.title} - ${item.object}`" item-value="id"></v-select>
                <v-file-input v-model="notice.file_letter" placeholder="Charger le fichier de la lettre à joindre"
                  label="Insérer le fichier de la lettre à joindre" multiple prepend-icon="mdi-paperclip">
                  <template v-slot:selection="{ text }">
                    <v-chip small label color="primary">{{ text }}</v-chip>
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" text @click="close_avis"> ANNULER L'ENVOI</v-btn>
          <v-btn small color="green darken-1" text @click="sendNotice">ENVOYER
            L'AVIS</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn right small color="primary" dark class="mb-2" @click="open_avis">
      <v-icon small class="mr-2">mdi-plus</v-icon>ENVOYER UN AVIS AUX AUTORITES
    </v-btn>
    <v-data-table locale="fr" :headers="headers" @click:row="goto" :search="search"
      no-data-text="Aucun Avis d&#39;Appel à Concurrence disponible" :items="this.$store.getters['Auth/getListAvis']"
      sort-by="publiDate" class="elevation-1 mb-5 px-5">
      <template v-slot:[`item.colorState`]="{ item }">
        <v-icon medium :color="item.colorState.colorCode">mdi-circle</v-icon>
      </template>
      <template v-slot:[`item.deadline`]="{ item }">{{
        item.deadline ? item.deadline : "--" | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z")
      }}</template>
      <template v-slot:[`item.publiDate`]="{ item }">{{
        item.publiDate | moment("dddd, Do MMMM YYYY à HH:mm:ss A Z")
      }}</template>
      <template v-slot:[`item.valid`]="{ item }">
        <v-chip label small outlined :color="`${item.valid ? 'green' : 'red'}`">
          {{ formatValid(item.valid) }}
        </v-chip>
      </template>
      <template v-slot:[`item.published`]="{ item }">
        <v-chip label small outlined :color="`${item.published ? 'green' : 'red'}`">
          {{ formatPublish(item.published) }}
        </v-chip>
      </template>
      <template v-slot:[`item.sended`]="{ item }">
        <v-chip label small outlined :color="`${item.sended ? 'green' : 'red'}`">
          {{ formatSend(item.sended) }}
        </v-chip>
      </template>
      <template v-slot:top>
        <v-toolbar flat color="white" class="mb-5">
          <v-toolbar-title v-show="$vuetify.breakpoint.mdAndUp">Liste détaillée des avis d’appel à la
            Concurrence</v-toolbar-title>
          <v-divider class="mx-4" inset vertical v-show="$vuetify.breakpoint.mdAndUp"></v-divider>
          <v-spacer v-show="$vuetify.breakpoint.mdAndUp"></v-spacer>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Recherchez un avis" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
    </v-data-table>
  </v-container>
</template>
  
<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: { DatePicker },
  data: () => ({
    search: "",
    items: [
      {
        text: "Tableau de bord",
        disabled: false,
        href: "/dashboard"
      },
      {
        text: "Mes Avis",
        disabled: true
      }
    ],
    dog: true,
    noticePpm: [
      {
        id: 1,
        title: "Réparation route nationale"
      }
    ],
    noticeType: [],
    notice: {
      id: [],
      file_letter: []
    },
    dialog: false,
    headers: [
      {
        text: " Statuts des avis en cours ou expirés",
        align: "start",
        sortable: false,
        value: "colorState"
      },
      {
        text: "Objet de l’avis",
        sortable: true,
        value: "object"
      },
      {
        text: "Date/heure de publication de l’avis",
        sortable: true,
        value: "publiDate"
      },
      { text: "Date/heure limite de remise des plis (Expression d’Intérêts / Offres / Propositions)", value: "deadline", sortable: true },
      { text: "Types d'avis", value: "noticeType.title", sortable: true },
      { text: "PPM", value: "ppm.title", sortable: true },
      {
        text: "Validation",
        sortable: false,
        filterable: false,
        value: "valid",
        align: "center",
        formatValid: (value) => (value ? "validé" : "non validé")
      },
      {
        text: "Status",
        sortable: false,
        filterable: false,
        value: "published",
        align: "center",
        formatPublish: (value) => (value ? "publié" : "non publié")
      },
      {
        text: "Etat",
        sortable: false,
        filterable: false,
        value: "sended",
        align: "center",
        formatSend: (value) => (value ? "envoyé" : "non envoyé")
      }
    ],
    desserts: [],
    editedIndex: -1
  }),
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    }
  },
  computed: {
    filteredAvis() {
      return this.$store.getters['Auth/getListAvis'].filter(item => !item.sended && item.published);
    },
    formTitle() {
      return this.editedIndex === -1 ? "Envoyer un avis aux organes de régulation et de contrôle" : "Création du Plan de Passation des Marchés";
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  created() {
    const cur_year = new Date().getFullYear();
    this.$store.dispatch("Auth/loadAllPPMPublished", cur_year);
    this.$store.dispatch("Auth/loadAllNotice");
    this.$store.dispatch("Auth/loadAllDoc");
    this.$store.dispatch("Auth/getData");

    console.log(this.$store.getters['Auth/getListAvis']);
  },
  methods: {
    ...mapActions({
      sendNoticeInfos: "Auth/sendNoticeToAuth",
      loadAllNotice: "Auth/loadAllNotice"
    }),
    open_avis() {
      this.$store.commit("Auth/OPEN_AVIS", true);
    },
    close_avis() {
      this.$store.commit("Auth/OPEN_AVIS", false);
    },
    formatValid(value) {
      return this.headers.find(header => header.value === "valid").formatValid(value);
    },
    formatPublish(value) {
      return this.headers.find(header => header.value === "published").formatPublish(value);
    },
    formatSend(value) {
      return this.headers.find(header => header.value === "sended").formatSend(value);
    },
    goto(value) {
      const { id } = value;
      this.$router.push({ name: "showAvisEnvoiAc", params: { id: id } });
    },
    async sendNotice() {
      const data = new FormData();
      data.append("notice_id", this.notice.id);
      if (this.notice.file_letter) {
        data.append("file_letter", this.notice.file_letter[0]);
      } else {
        data.append("file_letter", null);
      }
      try {
        await this.sendNoticeInfos(data);
        this.notice.id = [];
        this.notice.file_letter = [];
        this.close_avis(); // Ferme le dialogue après l'envoi réussi
      } catch (error) {
        console.error("Erreur lors de l'envoi de l'avis :", error);
        // Gérer l'erreur ici, par exemple, afficher un message à l'utilisateur
      }
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = { ...item };
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.desserts.splice(index, 1);
    },
    getPPM(item) {
      console.log(item);
      this.$router.push({ name: "user", params: { ppm: item } });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
};
</script>
<style>
.vue-daterange-picker {
  width: 100% !important;
}

.mx-datepicker {
  width: 100% !important;
}

.w-62em {
  height: 62em !important;
  width: 100% !important;
}

.v-card__text {
  width: 100% !important;
}

.vue-friendly-iframe iframe {
  width: 100% !important;
  height: 62em !important;
}

h4{
  word-break: break-word;
}
</style>
